import { render } from "./index.vue?vue&type=template&id=44ddfad3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=44ddfad3&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ddfad3"],['__file',"src/views/modelSetting/modelInstance/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44ddfad3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44ddfad3', __exports__)) {
    console.log('reload')
    api.reload('44ddfad3', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=44ddfad3&scoped=true", () => {
    console.log('re-render')
    api.rerender('44ddfad3', render)
  })

}


export default __exports__